export default __webpack_public_path__ + "static/media/shopping-bag.23a4adcb.svg";